import 'angular:locale/data:fr';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "fr";
